import { buildRels, imageCdnUrl, requestGapi } from "@src/utils/request"
import React, { useEffect, useRef, useState } from "react"
import { gameIds } from "./games_data"
import * as styles from "./gamesList.module.scss"
import Clickable from "@src/components/clickable"

const PAGE_LIMIT = 10
const totalPage = Math.ceil(gameIds.length / PAGE_LIMIT)
const getPageIds = (page) => {
  const start = (page - 1) * PAGE_LIMIT
  const end = start + PAGE_LIMIT
  return gameIds.slice(start, end)
}
const formatData = (res) => {
  return buildRels(res)
}

let cachedData = []
let cachedPage = 1

const GamesList = () => {
  const [page, setPage] = useState(cachedPage)
  const [data, setData] = useState(cachedData)
  const [requesting, setRequesting] = useState(false)

  const saveData = (res) => {
    const newData = formatData(res)
    setData((data) => {
      const list = data.concat(newData)
      cachedData = list
      return list
    })
  }
  const savePage = (page) => {
    cachedPage = page
    setPage(page)
  }
  const request = async (page) => {
    if (requesting || page > totalPage) {
      return
    }
    setRequesting(true)
    const ids = getPageIds(page)
    const res = await requestGapi(
      `/games?filter[id]=${ids.join(",")}&include=tags`
    )
    saveData(res)
    savePage(page)
    setRequesting(false)
  }

  useEffect(() => {
    if (data.length === 0) {
      request(1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const scrollEvent = () => {
      const bottomOffset = 800
      const top = window.pageYOffset
      const containerHeight = window.innerHeight
      const totalScroll = window.document.documentElement.scrollHeight
      const currentScroll = top + containerHeight
      const isBottom = currentScroll + bottomOffset + 20 >= totalScroll
      if (isBottom) {
        request(page + 1)
      }
    }
    window.addEventListener("scroll", scrollEvent)
    return () => {
      window.removeEventListener("scroll", scrollEvent)
    }
  })

  console.log("data", data)
  return (
    <>
      <div className={styles.games}>
        {data.map((game) => {
          return (
            <Clickable
              appNavTo={`https://www.gcores.com/games/${game.id}`}
              className={styles.game}
              key={game.id}
            >
              <img
                src={imageCdnUrl(game.attributes.cover, { w: 185, h: 110 })}
                alt={game.attributes.title}
              />
              <div className={styles.gameBody}>
                <h3>{game.attributes.title}</h3>
                <p>
                  {game.rels.tags
                    .filter((tag) =>
                      ["GameGenre", "Style"].includes(
                        tag.attributes["tag-type"]
                      )
                    )
                    .map((tag) => {
                      return (
                        <span key={tag.id} className="tag">
                          {tag.attributes.name}
                        </span>
                      )
                    })}
                </p>
              </div>
              <span>&gt;</span>
            </Clickable>
          )
        })}
      </div>
      <div className={styles.tip}>
        {requesting && <p>加载中...</p>}
        {page === totalPage && <p>已加载完毕</p>}
      </div>
    </>
  )
}

export default GamesList
